import { ref } from 'vue'

export const LS_KEY = 'wc-dont-show-anymore-forwarding-notification'

export const isHiddenForwardingEnabledNotification = ref(localStorage.getItem(LS_KEY) ?? false)

export const hideForwardingEnabledNotification = (dontShowAnymore: boolean) => {
  isHiddenForwardingEnabledNotification.value = true

  if (dontShowAnymore) {
    localStorage.setItem(LS_KEY, 'true')
  }
}

export const showForwardingEnabledNotification = () => {
  isHiddenForwardingEnabledNotification.value = false

  localStorage.removeItem(LS_KEY)
}
